// mutations.js

export default {
    updateRemoteConfigs(state, payload){
        state.remoteConfigs = payload
    }
};
